import { render, staticRenderFns } from "./render.vue?vue&type=template&id=1654134b&"
import script from "./render.vue?vue&type=script&lang=js&"
export * from "./render.vue?vue&type=script&lang=js&"
import style0 from "./render.vue?vue&type=style&index=0&id=1654134b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports